import {
  ChangeEvent,
  ChangeEventHandler,
  ReactElement,
  memo,
  useCallback,
  useEffect,
  useState
} from 'react';
import '../styles.css';

interface CheckboxProps {
  description?: string | ReactElement;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
  disabled?: boolean;
  id?: string;
  name?: string;
  classNamesForDescription?: string;
}

const _Checkbox = ({
  description,
  onChange,
  checked = false,
  disabled,
  id,
  name,
  classNamesForDescription
}: CheckboxProps) => {
  const [isChecked, setIsChecked] = useState<boolean>(checked);

  const handleChange: ChangeEventHandler<HTMLInputElement> = useCallback(
    (e) => {
      // setIsChecked(!isChecked);
      onChange?.(e);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isChecked, onChange]
  );

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  return (
    <div className="flex gap-4">
      <div className="relative er-checkbox max-h-[15px] min-h-[15px] min-w-[15px] flex">
        <input
          type="checkbox"
          className="absolute z-20 opacity-0 cursor-pointer w-full h-full"
          id={id}
          name={name}
          checked={isChecked}
          disabled={disabled}
          onChange={handleChange}
        />
        <span
          className="z-10 border-[2px] bg-i_checkout_bg border-i_checkout_border relative inline-block min-h-[17px] min-w-[16px]
        after:content-[''] after:w-full after:h-full after:absolute after:top-0 after:opacity-1 after:text-xs"></span>
      </div>
      <p className={`${classNamesForDescription ?? ''}`}>{description}</p>
    </div>
  );
};

export const Checkbox = memo(_Checkbox);
